import { AuthGuard } from '@/core/auth/auth.guard';
import { keycloakCallbackGuard } from '@/core/auth/keycloak-callback.guard';
import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/component/app.layout';
import { Dashboard } from '@/features/dashboard';
import { SemAcesso } from '@/core/permissions/sem-acesso/sem-acesso';
import { portalRoutes } from '@/features/portal/portal.routes';
import { registroRoutes } from '@/features/registro/registro.routes';
import { financeiroRoutes } from '@/features/financeiro/financeiro.routes';
import servicosRoutes from '@/features/servicos/servicos.routes';
import solicitacoesRoutes from '@/features/solicitacoes/solicitacoes.routes';
import comissoesRoutes from '@/features/comissoes/comissoes.routes';
import gestaoRoutes from '@/features/gestao/gestao.routes';
import configuracoesRoutes from '@/features/configuracoes/configuracoes.routes';

export const featuresRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', component: Dashboard },
            { path: 'sem-acesso', component: SemAcesso },
            ...financeiroRoutes,
            ...portalRoutes,
            ...registroRoutes,
            ...servicosRoutes,
            ...comissoesRoutes,
            ...solicitacoesRoutes,
            ...gestaoRoutes,
            ...configuracoesRoutes
        ],
        canActivate: [keycloakCallbackGuard, AuthGuard]
    }
];

export default featuresRoutes;
